<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/40Ktrr/images/cover.jpg?1684515576175" alt="This image is the cover for the book Roped, Guards of Folsom"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">Roped, Guards of Folsom
      </h1>
      <p class="bookDescription body article font2">
        <p><b><i>Guards of Folsom: Book Four </i></b></p><p><em>Life has been known by a series of constants. Violence, anger, drugs, sex, death, heartbreak, pain, fear and the most common, hunger. Always hunger. Not the kind that can be satisfied with food, but the kind born of circumstance. The kind that not only claws within a gut, but settles into a heart, consumes a mind. Deeper. Encircles, penetrates the soul. Hunger for something more, something better, safer. Always just out of grasp.</em></p> <p><em>Craving. Starved.</em></p> <p><em>It’s part of me.</em></p> <p><em>Who I am.</em></p> <p><em>Born of blood and violence, hunger is my fate.</em></p> <p><em>Yet, the slightest things can change the directions of a life. An unplanned circumstance, random act—a connection—a chance event, like a lightning strike, fate trumped.</em></p> <p><em>Jamie is my lightning strike.<br/> Tek Cain</em></p> <p>Tek Cain was cultivated from birth to lead the motorcycle gang, Crimson Eight. Jamie Ryan, his best friend, is destined to be his second. But forbidden desires have them questioning everything they know, and an undeniable bond makes them want more than their supposed brotherhood can provide. Their love could get them killed, but they are bound to each other—from the cradle to the grave.</p>
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        SJD Peterson
      </h2>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?924d1742